module.exports = __webpack_public_path__ + "img/culture03.9387a9d1.jpg";